module.exports = __webpack_public_path__ + "static/vinyl-records.bc42084a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vinyl-records.jpg
// module id = 487
// module chunks = 114276838955818